import { privateApi } from '@shared/config/axios.config';

import { Lesson, LessonContent, LessonStats, NoteDTO } from '../model/types';
import { parseNoteDTO } from '../lib/parsers';

interface GetLessonParams {
  id: string;
}

interface LessonStatsDTO {
  total_count: number;
  completed_count: number;
  completed: boolean;
}

interface LessonDTO {
  id: string;
  module_id: string;
  title: string;
  order: number;
  lesson_number?: number;
  content_link: string;
  created_at: string;
  updated_at: string;
  sections: LessonContent[];
  notes: NoteDTO[];
  stats: LessonStatsDTO;
}

export const getLessonApi = (params: GetLessonParams) => {
  return privateApi.get<LessonDTO>(`/account/content/lesson/${params.id}`).then(
    ({ data }) =>
      ({
        id: data.id,
        moduleId: data.module_id,
        title: data.title,
        order: data.order,
        lessonNumber: data.lesson_number,
        contentLink: data.content_link,
        createdAt: data.created_at,
        updatedAt: data.updated_at,
        sections: data.sections,
        notes: data.notes
          .map((dto) => parseNoteDTO(dto))
          .sort((a, b) => b.createdAt.localeCompare(a.createdAt)),
        stats: {
          totalCount: data.stats.total_count,
          completedCount: data.stats.completed_count,
          completed: data.stats.completed,
        } as LessonStats,
      }) as Lesson,
  );
};

interface CompleteLessonPayload {
  lesson_id: string;
  module_id: string;
  section_ids: string[];
}

export const completeLessonApi = (payload: CompleteLessonPayload) => {
  return privateApi.put('/account/progress/lesson/multi', payload);
};

interface CompleteSubscriptionLessonPayload {
  plan_id: string;
  lesson_number: number;
}

export const completeSubscriptionLessonApi = (payload: CompleteSubscriptionLessonPayload) => {
  return privateApi.put('/account/progress/subscription/lesson', payload);
};
